import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { changeWifiConnectivityAction, hasNetworkConnectionAction, noNetworkConnectionAction } from './connectivity.actions';

@Injectable()
export class ConnectivityEffects {
  constructor(private action$: Actions) {}

  protected changeWifiConnectivity$ = createEffect(() =>
    this.action$.pipe(
      ofType(changeWifiConnectivityAction),
      switchMap((action) => {
        if (action.status) {
          return of(hasNetworkConnectionAction());
        } else {
          return of(noNetworkConnectionAction());
        }
      })
    )
  );
}
